/* eslint-disable react/require-default-props */
import * as React from "react";
import { FieldProps } from "formik";
import { cx } from "@emotion/css";
import { translateSpecialCharacters } from "../support/translateSpecialCharacters";
import formGroupStyles from "../css/formgroup.module.css";

interface OtherProps {
  label: string;
  isReadOnly?: boolean;
  onMount?: () => void;
}

type FieldTextProps = FieldProps & OtherProps;

const FieldText = ({
  field,
  form: { touched, errors, setFieldValue, handleBlur },
  label,
  isReadOnly = false,
  onMount
}: FieldTextProps): React.JSX.Element => {
  const fieldClasses = cx(
    formGroupStyles["form-group"],
    touched[field.name] && errors[field.name] ? formGroupStyles.error : ""
  );

  const formatInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    handleBlur(event);
    setFieldValue(field.name, event.target.value.trim());
  };

  React.useEffect(() => {
    // excute side effect onMount method
    if (onMount) onMount();
  }, [onMount]);

  return (
    <div className={fieldClasses}>
      <label htmlFor={field.name}>{label}</label>

      <div className={formGroupStyles["input-group"]}>
        {isReadOnly ? (
          <p id={field.name} className={formGroupStyles.bold}>
            {field.value}
          </p>
        ) : (
          <input
            spellCheck="false"
            type="text"
            {...field}
            id={field.name}
            onBlur={formatInput}
            onChange={e => {
              setFieldValue(
                field.name,
                translateSpecialCharacters(e.target.value)
              );
            }}
          />
        )}
        <div className={formGroupStyles["error-messages"]}>
          {touched[field.name] && errors[field.name] && (
            <div id={`${field.name}ErrorMessage`}>
              {errors[field.name] as React.ReactNode}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FieldText;
